<template>
    <div>
        <BaseModal 
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="$tc('Shared.Note', 2)"
            :width="'50%'"
            :height="'390px'"          
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK },                   
            ]"              
            @Close="close"
        >
            <b-row>
                <b-col lg="12" md="12" sm="12">
                    <MdMemo
                        v-bind:Name="'comments'"
                        v-bind:Rows="'14'"
                        v-bind:isAutoFocus="true"
                        v-bind:MaxRows="'14'"           
                        v-model="notes"
                        :isRequired="required"
                    />
                </b-col>
            </b-row>
        </BaseModal>
    </div>
</template>

<script>
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'MDTextEditorDialog',
    mixins: [validationMixin, ShowMessage],

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: true
        },
        handlerOk: {
            type: Function,
            required: true
        }
    },

    data() {
        return {
            modalId: 'TextEditorId',
            notes: this.value
        }
    },


    watch: {
        visible(newVal) {
            if (newVal) {
                this.emitCloseEvent= true;                
            }
        },
        value(newVal) {
            this.notes = newVal;
        }
    },

    methods: {
 
        emitEventCancel() {
            this.emitCloseEvent= false;
            this.$emit('close');
        },

        emitEventOK() {
            if (this.validate()) {
                this.$emit('input', this.notes);
                this.handlerOk(this.notes);
                this.$emit('ok');
            } else {
                if (!this.isValid('comments')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('comments'),"errorAutoHide"); 
                }
            }
        },

        onHidden() {
            this.notes = '';
            this.$emit('input', this.notes);

            if (this.emitCloseEvent) {
                this.$emit('close');
                this.emitCloseEvent= false;
            }
        },

        validate() {
            if (this.required) {
                const rules = {
                    comments: [
                        validationRules.required(
                            this.$t("PharmacyNotes.NotesRequired")
                        ),
                    ],
                };

                return this.validateFields(rules, {'comments': this.notes});
            }
            
            return true;
        },

        close() {
            this.emitEventCancel();
        },
    }
}
</script>